import { FC } from 'react';
import { Drawer } from 'rsuite';
import { useAppSelector } from 'hooks/redux';
import { getText } from 'utils/stringUtil';
import { PR_EDIT_YOUR_ANSWERS, PR_UPDATE } from 'constants/languageConstants';
import { PLAN_RECOMMENDER_QUESTIONS } from 'modules/planRecommender/pages/constants';
import iconBack from 'images/icons/icon-back.png';
import { getCurrentAnswerByQuestionType } from 'modules/planRecommender/pages/PlanRecommender/PlanRecommender';

import styles from './PlanRecommenderEditDrawerMobile.module.less';

type PlanRecommenderEditDrawerMobileProps = {
  children: any;
  isdrawerOpen: boolean;
  onClose: () => void;
  onFetchResult: Function;
  isValidState: boolean;
  answers: any;
  questions: any;
};

const PlanRecommenderEditDrawerMobile: FC<
  PlanRecommenderEditDrawerMobileProps
> = (props: PlanRecommenderEditDrawerMobileProps) => {
  const language = useAppSelector((state) => state.benguide.data?.language);
  const {
    isdrawerOpen,
    onClose,
    children,
    onFetchResult,
    isValidState,
    answers,
    questions,
  } = props;

  const updatePlans = () => {
    onFetchResult();
    onClose();
  };

  const isEnableUpdateButton = () => {
    let isEnable = true;
    answers.forEach((answerObj: any) => {
      const { answer } = answerObj;
      if (Array.isArray(answer)) {
        isEnable = answer.length > 0 && isEnable;
      }
    });
    (
      getCurrentAnswerByQuestionType(
        questions,
        PLAN_RECOMMENDER_QUESTIONS.PRESCRIPTIONS
      ) || []
    ).forEach((answer: any) => {
      isEnable = answer !== '' && isEnable;
    });
    return isEnable;
  };

  return (
    <Drawer
      show={isdrawerOpen}
      onHide={onClose}
      size="md"
      className={styles.editDrawer}
    >
      <Drawer.Header>
        <div className={styles.editModeHeaderWrapper}>
          <div className={styles.editYourAnswers}>
            <img
              className={styles.backArrow}
              onClick={onClose}
              src={iconBack}
            />
            {getText(PR_EDIT_YOUR_ANSWERS, language)}
          </div>
          <div className={styles.splitter}>
            <hr className={styles.hrTag} />
          </div>
        </div>
      </Drawer.Header>
      <Drawer.Body className={styles.drawerBody}>
        <div className={styles.editModeWrapper}>{children}</div>
        <button
          className={styles.updateButton}
          onClick={updatePlans}
          disabled={!(isValidState && isEnableUpdateButton())}
        >
          {getText(PR_UPDATE, language)}
        </button>
      </Drawer.Body>
    </Drawer>
  );
};
export default PlanRecommenderEditDrawerMobile;
